module.exports = __webpack_public_path__ + "static/media/video-tour-new.4f7f4f52.svg";